/**
 * Return an object with the current subdomain and domain values.
 */
export function parseDomain(): { subdomain: string; domain: string } {
   const matches = window.location.host.match(/\b([^.]+)\.([^.]+\.[^.]+)$/);
   return {
      subdomain: matches?.[1] ?? '',
      domain: matches?.[2] ?? window.location.host,
   };
}
